module.exports = __webpack_public_path__ + "static/light-logo-23-eb55126c534f9d1f44693c6b5bc4b1a6.png";